import * as z from "zod/v4";

export const recordPackageProtectionPriceExposure = {
  name: "recordPackageProtectionPriceExposure" as const,
  input: z.object({
    anonymousId: z.string(),
    treatmentId: z.string().optional(),
    isStagecoachArm: z.boolean(),
    modelVersionId: z.string().optional(),
    betaSampleIndex: z.number().optional(),
    packageProtectionPriceDollars: z.number().optional(),
    returnsCoveragePriceDollars: z.number().optional(),
    cartValue: z.number(),
    cartItemCount: z.number(),
    cartHash: z.string(),
    checkoutProbability: z.number().optional(),
  }),
  output: z.null(),
};
